const httpEventsSubscriberRegistry = (() => {
  const httpEventSubscribers = [];

  return {
    addSubscriber: (subscriber) => {
      httpEventSubscribers.push(subscriber);
    },
    notifyRequest: () => {
      httpEventSubscribers.forEach((subscriber) => {
        subscriber.notifyRequest();
      });
    },
    notifyResponse: () => {
      httpEventSubscribers.forEach((subscriber) => {
        subscriber.notifyResponse();
      });
    },
  };
})();

export default {
  name: 'HttpEventPublisher',

  subscribe: (subscriber) => {
    httpEventsSubscriberRegistry.addSubscriber(subscriber);
  },
  publishRequest: () => {
    httpEventsSubscriberRegistry.notifyRequest();
  },
  publishResponse: () => {
    httpEventsSubscriberRegistry.notifyResponse();
  },
};

export class HttpEventSubscriber {
  constructor(onRequest, onResponse) {
    this.onRequest = onRequest;
    this.onResponse = onResponse;
  }

  notifyRequest(args) {
    this.onRequest(args);
  }

  notifyResponse(args) {
    this.onResponse(args);
  }
}
